module.exports = __webpack_public_path__ + "static/jetpack-022c7381d57ff676033fc3b284283e64.png";